//tip
//this is use to send tip from viewer side
export const TIP_SEND_REQUEST = "TIP_SEND_REQUEST";
export const TIP_SEND_RECEIVE = "TIP_SEND_RECEIVE";
export const TIP_SEND_FAILURE = "TIP_SEND_FAILURE";
export const TIP_SEND_RESET = "TIP_SEND_RESET";

//this is use to get tip data list
export const TIP_DATA_REQUEST = "TIP_DATA_REQUEST";
export const TIP_DATA_RECEIVE = "TIP_DATA_RECEIVE";
export const TIP_DATA_FAILURE = "TIP_DATA_FAILURE";
export const TIP_DATA_RESET = "TIP_DATA_RESET";

//this is use to send tip for tip goal from viewer side
export const TIP_GOAL_SEND_REQUEST = "TIP_GOAL_SEND_REQUEST";
export const TIP_GOAL_SEND_RECEIVE = "TIP_GOAL_SEND_RECEIVE";
export const TIP_GOAL_SEND_FAILURE = "TIP_GOAL_SEND_FAILURE";
export const TIP_GOAL_SEND_RESET = "TIP_GOAL_SEND_RESET";

//this is use to get tip goal data list
export const TIP_GOAL_DATA_REQUEST = "TIP_GOAL_DATA_REQUEST";
export const TIP_GOAL_DATA_RECEIVE = "TIP_GOAL_DATA_RECEIVE";
export const TIP_GOAL_DATA_FAILURE = "TIP_GOAL_DATA_FAILURE";
export const TIP_GOAL_DATA_RESET = "TIP_GOAL_DATA_RESET";